"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectSeparator = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var Separator_1 = require("../Separator/Separator");
exports.SelectSeparator = function (_a) {
    var className = _a.className, otherProps = tslib_1.__rest(_a, ["className"]);
    return (react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default("gd-select-separator", className) }, otherProps),
        react_1.default.createElement(Separator_1.Separator, null)));
};
//# sourceMappingURL=SelectSeparator.js.map